<template>
  <!-- [2026-10-04] 总仓功能升级公告（内容前端写死, 随 V3 仓位规则发版）:
       仅对「还有 XX默认仓 存量」的厂弹出 (拉取该厂仓位列表按名判断), 点「我知道了」
       后 localStorage 记忆不再弹; 换公告内容时递增 NOTICE_KEY 版本号让用户重新可见。
       组件此前是好粮宝更新贴脸公告 (2026-09-28 清空停用), 复用其全局公告壳。 -->
  <a-modal
    v-model="visible"
    :mask-closable="false"
    :keyboard="false"
    :closable="false"
    width="560px"
    centered
  >
    <template slot="title">
      <div style="display: flex; align-items: center; gap: 8px">
        <a-icon type="notification" theme="twoTone" />
        <span>系统公告</span>
      </div>
    </template>

    <div style="padding: 4px 2px">
      <p style="font-size: 15px; font-weight: 600; margin-bottom: 12px">
        尊敬的用户您好：
      </p>
      <p style="font-size: 14px; line-height: 1.9; margin-bottom: 10px">
        系统升级了仓位规则：以后过磅<b>不选仓位时，统一记到「总仓」</b>——一个厂只有
        一个粮食总仓、一个农资总仓，库存按品种记总账，<b>不再按品种自动建「XX默认仓」</b>。
      </p>
      <div
        style="
          font-size: 13px;
          line-height: 1.9;
          background: #fff7e6;
          border: 1px solid #ffd591;
          border-radius: 4px;
          padding: 10px 12px;
          margin-bottom: 10px;
        "
      >
        <b>需要您配合处理：</b
        >您厂里以前自动建出的「XX默认仓」（如「普优默认仓」），请把里面的库存挪到「总仓」。两种方式任选：<br />
        ① 自己动手（约几分钟）：粮食在「粮食仓」、农资在「农资仓」页面——把旧默认仓里各品种逐行「盘点」清零，再在「总仓」把相同品种「盘点」成一样的数。<b>若还没有「总仓」或总仓里还没有该品种</b>：点页面右上角「新建」加一行，仓位名称<b>一字不差</b>填「总仓」（农资的叫「农资总仓」），选好品种填上数量即可；<br />
        ② 不方便自己操作的：<b>在群里说一声，或联系您的业务员</b>，我们安排技术人员一对一帮您合并。
      </div>
      <p style="font-size: 12.5px; color: #999; margin-bottom: 0">
        暂时不处理也不影响正常出入库，只是库存分散在几个旧仓位里，看总账要切换着看；处理前后库存总数不变，已有的单据和账目数据都不受影响。有问题欢迎随时在群里反馈。
      </p>
    </div>

    <template slot="footer">
      <!-- [2026-10-05] 强制滞留 3 秒: 按钮倒计时期间禁用, 防用户没读公告就秒关 -->
      <a-button type="primary" :disabled="countdown > 0" @click="dismiss">
        我知道了{{ countdown > 0 ? `（${countdown}s）` : '' }}<span style="font-size: 12px; color: #999">（点击后不再提醒）</span>
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { listWareareas, listWareareasCached } from '@/api/dryingWarearea'

// 公告内容版本号：换公告内容时递增 (V1→V2)，让点过「我知道了」的用户重新可见
const NOTICE_KEY = 'HL_TOTAL_BIN_NOTICE_V1'

// 旧「XX默认仓」识别：名字以"默认仓"结尾且不是「总仓」(含老的不带品种的「默认仓」——它也要并进总仓)
function isLegacyDefaultWa(name) {
  const n = String(name || '').trim()
  return /默认仓$/.test(n) && n !== '总仓'
}

export default {
  name: 'WebboxUpdateNotice',
  data() {
    return {
      visible: false,
      countdown: 0
    }
  },
  mounted() {
    // 稍等页面/登录态加载完再查 (与旧版公告同节奏), factoryId 未就绪时延迟重试
    this._tries = 0
    this._timer = setTimeout(() => this.check(), 1200)
  },
  beforeDestroy() {
    if (this._timer) { clearTimeout(this._timer); delete this._timer }
    if (this._cdTimer) { clearInterval(this._cdTimer); delete this._cdTimer }
  },
  methods: {
    /** [2026-10-05] 弹窗强制滞留 3 秒: 「我知道了」倒计时期间禁用 */
    startCountdown() {
      this.countdown = 3
      if (this._cdTimer) { clearInterval(this._cdTimer); delete this._cdTimer }
      this._cdTimer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) { clearInterval(this._cdTimer); delete this._cdTimer }
      }, 1000)
    },
    /** 已点过「我知道了」→ 不再弹 (换公告内容时递增 NOTICE_KEY 即可重新触达) */
    isDismissed() {
      try {
        return window.localStorage.getItem(NOTICE_KEY) === '1'
      } catch (e) {
        return false
      }
    },
    dismiss() {
      try {
        window.localStorage.setItem(NOTICE_KEY, '1')
      } catch (e) { /* 隐私模式存不进去就算了, 下次再弹 */ }
      this.visible = false
    },
    factoryId() {
      const org = (this.$store && this.$store.state && this.$store.state.externalOrg) || {}
      const u = (this.$store && this.$store.state && this.$store.state.loginUser) || {}
      return org.saleOrgId || u.externalOrgId || ''
    },
    /** 只对「还有旧 XX默认仓」的厂弹 (粮食+农资任一命中即弹); 没有旧默认仓的厂零打扰 */
    async check() {
      if (this.isDismissed()) return
      const fid = this.factoryId()
      if (!fid) {
        // 登录态/Vuex 还没就绪: 最多再试 4 次 (约 12s 内), 仍拿不到就放弃本次 (下次进页再查)
        if (++this._tries > 4) return
        this._timer = setTimeout(() => this.check(), 3000)
        return
      }
      try {
        const [grainWas, inputWas] = await Promise.all([
          listWareareasCached(fid, 'grain').catch(() => []),
          listWareareasCached(fid, 'input').catch(() => [])
        ])
        const has = (grainWas || []).concat(inputWas || []).some(w => isLegacyDefaultWa(w.name))
        if (has) { this.visible = true; this.startCountdown() }
      } catch (e) {
        // 仓位列表拉不到: 不误弹, 下次进页再查
      }
    }
  }
}
</script>
